import {
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  ELSPendoService,
} from '@els/els-ui-common-react';
import { AppConstants } from '../app/app.constants';
import { AppContext } from '../app/AppProvider.component';
import {
  getPendoConfig,
} from './analytics-registrar.utilities';
import { ApiStatus } from '../app/app-state.types';
import { isOsmosisAI } from '../../pages/ai-chat/ai-chat.utilities';

const AnalyticsRegistrar = (): JSX.Element => {
  const { appState } = useContext(AppContext);
  const [isPendoLoaded, setIsPendoLoaded] = useState(false);

  useEffect(() => {
    if (isOsmosisAI(appState.appLinkData)) {
      window.isHideForsta = true
    }
  }, [appState.appLinkData]);

  useEffect(() => {
    ELSPendoService.injectScript(AppConstants.PENDO_API_KEY);

    // Poll for window.pendo to be available
    const checkPendo = setInterval(() => {
      if (window.pendo) {
        setIsPendoLoaded(true);
        clearInterval(checkPendo);
      }
    }, 100);

    // Cleanup: clear interval after 10 seconds if pendo never loads
    const timeout = setTimeout(() => {
      clearInterval(checkPendo);
    }, 10000);

    return () => {
      clearInterval(checkPendo);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    // Wait for crosswalk API to complete (regardless of success/404/error)
    const isCrosswalkComplete = appState.crosswalkApiStatus !== ApiStatus.IDLE
      && appState.crosswalkApiStatus !== ApiStatus.LOADING;

    if (
      !isPendoLoaded
      || !window.pendo
      || !appState.currentCourse
      || !isCrosswalkComplete
      || !appState.eolsUser
      || !appState.entitlements
    ) {
      return;
    }
    const config = getPendoConfig(appState);
    window.pendo.initialize(config);
  }, [
    isPendoLoaded,
    appState.currentCourse,
    appState.crosswalkApiStatus,
    appState.eolsUser,
    appState.entitlements
  ]);

  return null;
};

export default AnalyticsRegistrar;
